// extracted by mini-css-extract-plugin
export default {"cls1":"Stats-cls1___d7c8a0587c26f9bc7a8","cls2":"Stats-cls2___2e780e3e8be96a4523e Stats-cls1___d7c8a0587c26f9bc7a8"};